<template>
  <div class="row">
    <div class="col-lg-3">
      <!--begin::Card-->
      <div class="card card-custom card-stretch">
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">{{ $t("events.title") }}</h3>
          </div>
          <div class="card-toolbar">
            <button
              @click="dialog = true"
              class="btn btn-light-primary font-weight-bold"
            >
              <i class="ki ki-plus"></i>{{ $t("events.addEvent") }}
            </button>
          </div>
        </div>
        <div class="card-body" v-b-scrollspy="10">
          <div id="kt_calendar_external_events" class="fc-unthemed">
            <div
              v-for="(item, index) in plannings"
              :key="index"
              :style="{ backgroundColor: item.color }"
              v-if="item.type === 'calendar'"
              class="fc-draggable-handle label font-weight-bolder label-lg label-inline mb-5 w-100 cursor-move h-50 text-white"
              draggable="true"
              @dragstart="dragEl"
              :data-color="item.color"
              :id="`plan-item-${index}`"
              v-b-tooltip.hover.left="item.description"
            >
              <p class="text-truncate" style="width: 12rem; height: 1rem">
                {{ item.title }}
              </p>
              <div class="row justify-content-end ml-1">
                <div>
                  <v-btn icon rounded text x-small @click="deleted(item)">
                    <v-icon class="text-white text-hover-danger"
                      >mdi-delete-empty</v-icon
                    >
                  </v-btn>
                </div>
                <div class="mr-1">
                  <v-btn icon rounded text x-small @click="edit(item)">
                    <v-icon class="text-white text-hover-warning"
                      >mdi-pencil</v-icon
                    >
                  </v-btn>
                </div>
              </div>
            </div>
            <br />
          </div>
          <div class="separator separator-dashed my-10"></div>
          <div>
            <label class="checkbox checkbox-primary">
              <input type="checkbox" id="kt_calendar_external_events_remove" />
              {{ $t("events.removeAfterDrop") }}
            </label>
          </div>
        </div>
      </div>
      <!--end::Card-->
    </div>
    <div class="col-lg-9">
      <!--begin::Card-->
      <div class="card card-custom card-stretch">
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">{{ $t("events.calendar") }}</h3>
          </div>
        </div>
        <div class="card-body">
          <div id="kt_calendar"></div>
        </div>
      </div>
      <!--end::Card-->
    </div>
    <v-row justify="center">
      <v-dialog v-model="dialog" scrollable max-width="700px">
        <v-card>
          <v-card-title>
            <v-icon>mdi-calendar-edit</v-icon>
            {{ $t("events.createEvent") }}
            <v-spacer></v-spacer>
            <v-btn small icon rounded @click="closed">
              <v-icon color="red">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 400px">
            <v-row class="mt-5">
              <v-flex class="p-2" xs12 sm12 md6 xl6 lg6>
                <v-text-field
                  outlined
                  :label="$t('events.titleLabel')"
                  dense
                  v-model="title"
                  :error-messages="errors.title"
                ></v-text-field>
                <v-textarea
                  :error-messages="errors.description"
                  v-model="description"
                  :label="$t('events.descriptionLabel')"
                  outlined
                ></v-textarea>
              </v-flex>
              <v-flex class="p-2 mt-0 pt-0" xs12 sm12 md6 xl6 lg6>
                <v-color-picker
                  v-model="color"
                  :label="$t('events.colorLabel')"
                  outlined
                  required
                  dense
                  class="mt-1"
                  mode="rgba"
                  dot-size="18"
                  show-swatches
                  swatches-max-height="135"
                ></v-color-picker>
                <date-picker
                  v-model="start_at"
                  :label="$t('events.startDate')"
                  :format="
                    $i18n.locale === 'fa'
                      ? 'jYYYY/jMM/jDD HH:mm'
                      : 'YYYY-MM-DD HH:mm'
                  "
                  :display-format="
                    $i18n.locale === 'fa'
                      ? 'jYYYY/jMM/jDD HH:mm'
                      : 'YYYY-MM-DD HH:mm'
                  "
                  :locale="$i18n.locale"
                  type="datetime"
                  :min="getToday()"
                />
                <date-picker
                  v-model="end_at"
                  :label="$t('events.endDate')"
                  :format="
                    $i18n.locale === 'fa'
                      ? 'jYYYY/jMM/jDD HH:mm'
                      : 'YYYY-MM-DD HH:mm'
                  "
                  :display-format="
                    $i18n.locale === 'fa'
                      ? 'jYYYY/jMM/jDD HH:mm'
                      : 'YYYY-MM-DD HH:mm'
                  "
                  :locale="$i18n.locale"
                  type="datetime"
                  :min="start_at"
                />
              </v-flex>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="float-left">
            <v-spacer></v-spacer>
            <v-btn class="btn-cancel" @click="closed">
              <v-icon>mdi-close-circle</v-icon>
              {{ $t("events.close") }}
            </v-btn>
            <v-btn v-if="!updateable" class="submit-btn" @click="store">
              <span class="fa fa-bookmark icon-md ml-1"></span>
              {{ $t("events.save") }}
            </v-btn>
            <v-btn v-else class="submit-btn" @click="update">
              <v-icon>mdi-update</v-icon>
              {{ $t("events.update") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import "@fullcalendar/core/vdom";
import moment from "moment-jalaali";
// import '@/script.bundle';
import { Calendar } from "@fullcalendar/core";
import interaction from "@fullcalendar/interaction";
import dayGrid from "@fullcalendar/daygrid";
import timeGrid from "@fullcalendar/timegrid";
import list from "@fullcalendar/list";
import FullCalendarInteraction from "leaflet";
import Button from "@/view/pages/Button";
import faLocale from "@fullcalendar/core/locales/fa";
import enLocale from "@fullcalendar/core/locales/en-gb";
import arLocale from "@fullcalendar/core/locales/ar";

export default {
  components: { Button },
  props: ["plannings"],
  data() {
    return {
      title: null,
      errors: [],
      calendar_id: null,
      updateable: false,
      description: null,
      dialog: false,
      start_at: "",
      end_at: "",
      color: [],
      events: [],
      calendar: null,
    };
  },
  mounted() {
    this.setEvents();
    this.initCalendar();
  },
  watch: {
    "$i18n.locale": {
      handler(newLocale) {
        this.updateCalendarLocale();
      },
      immediate: true,
    },
  },
  methods: {
    getToday() {
      return moment().format("YYYY-MM-DD HH:mm");
    },
    dragEl(e) {
      e.dataTransfer.setData("text", e.target.id);
    },
    setEvents() {
      this.events = [];
      if (!this.plannings) return;
      Object.entries(this.plannings).map(([key, item]) => {
        if (item.type === "calendar") {
          this.events.push({
            title: item.title,
            url: null,
            start:
              this.$i18n.locale === "fa"
                ? moment(item.start_at, "jYYYY/jMM/jDD HH:mm").format(
                    "YYYY-MM-DD HH:mm"
                  )
                : item.start_at,
            end:
              this.$i18n.locale === "fa"
                ? moment(item.end_at, "jYYYY/jMM/jDD HH:mm").format(
                    "YYYY-MM-DD HH:mm"
                  )
                : item.end_at,
            className: "fc-event-solid-info fc-event-light",
            description: item.description,
          });
        }
      });
    },
    initExternalEvents() {
      $("#kt_calendar_external_events .fc-draggable-handle").each(function () {
        $(this).data("event", {
          title: $.trim($(this).text()),
          stick: true,
          classNames: [$(this).data("color")],
          description: "... ",
        });
      });
    },
    initCalendar() {
      const calendarEl = document.getElementById("kt_calendar");
      if (!calendarEl) {
        return;
      }
      const todayDate = moment().startOf("day");
      const YM = todayDate.format("YYYY-MM");
      const YESTERDAY = todayDate
        .clone()
        .subtract(1, "day")
        .format("YYYY-MM-DD");
      const TODAY = todayDate.format("YYYY-MM-DD");
      const TOMORROW = todayDate.clone().add(1, "day").format("YYYY-MM-DD");

      const containerEl = document.getElementById(
        "kt_calendar_external_events"
      );

      const Draggable = FullCalendarInteraction.Draggable;

      new Draggable(containerEl, {
        itemSelector: ".fc-draggable-handle",
        eventData: function (eventEl) {
          return $(eventEl).data("event");
        },
      });

      this.calendar = new Calendar(calendarEl, {
        plugins: [interaction, dayGrid, timeGrid, list],
        isRTL:
          this.$i18n.locale === "fa" ||
          this.$i18n.locale === "ar" ||
          this.$i18n.locale === "ar_ae" ||
          this.$i18n.locale === "ar_iq",
        locale:
          this.$i18n.locale === "fa"
            ? faLocale
            : this.$i18n.locale === "ar" ||
              this.$i18n.locale === "ar_ae" ||
              this.$i18n.locale === "ar_iq"
            ? arLocale
            : this.$i18n.locale === "en" ||
              this.$i18n.locale === "en_US" ||
              this.$i18n.locale === "en_GB"
            ? enLocale
            : enLocale,
        header: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        },
        height: 800,
        contentHeight: 780,
        aspectRatio: 3,
        nowIndicator: true,
        now: TODAY,
        views: {
          dayGridMonth: { buttonText: this.$t("events.views.month") },
          timeGridWeek: { buttonText: this.$t("events.views.week") },
          timeGridDay: { buttonText: this.$t("events.views.day") },
        },
        defaultView: "dayGridMonth",
        defaultDate: TODAY,
        droppable: true,
        editable: true,
        eventLimit: true,
        navLinks: true,
        events: this.events,
        drop: (arg) => {
          if ($("#kt_calendar_external_events_remove").is(":checked")) {
            $(arg.draggedEl).remove();
          }
        },
        eventRender: (info) => {
          const element = $(info.el);
          if (
            info.event.extendedProps &&
            info.event.extendedProps.description
          ) {
            if (element.hasClass("fc-day-grid-event")) {
              element.data("content", info.event.extendedProps.description);
              element.data("placement", "top");
              KTApp.initPopover(element);
            } else if (element.hasClass("fc-time-grid-event")) {
              element
                .find(".fc-title")
                .append(
                  '<div class="fc-description">' +
                    info.event.extendedProps.description +
                    "</div>"
                );
            } else if (element.find(".fc-list-item-title").length !== 0) {
              element
                .find(".fc-list-item-title")
                .append(
                  '<div class="fc-description">' +
                    info.event.extendedProps.description +
                    "</div>"
                );
            }
          }
        },
      });
      if (this.calender !== null) this.calendar.render();
      this.initExternalEvents();
    },
    updateCalendarLocale() {
      if (this.calendar) {
        this.calendar.destroy();
      }
      try {
        this.calendar.destroy();
      } catch (error) {
        console.error("Error destroying calendar:", error);
      }
      this.setEvents();
      this.initCalendar();
    },
    store() {
      this.$modal.showLoading();
      this.errors = [];
      this.requestApiPost("user/create-calendar", {
        title: this.title,
        description: this.description,
        color: this.color.hex,
        start_at:
          this.$i18n.locale === "fa"
            ? moment(this.start_at, "jYYYY/jMM/jDD HH:mm").format(
                "YYYY-MM-DD HH:mm"
              )
            : this.start_at,
        end_at:
          this.$i18n.locale === "fa"
            ? moment(this.end_at, "jYYYY/jMM/jDD HH:mm").format(
                "YYYY-MM-DD HH:mm"
              )
            : this.end_at,
      })
        .then(({ data }) => {
          this.$toast.success(this.$t("events.successAdd"));
          this.$modal.hideLoading();
          this.setEvents();
          this.updateCalendarLocale();
          this.$emit("getData");
          this.closed();
        })
        .catch(({ response }) => {
          this.$modal.hideLoading();
          this.errors = response.data.errors;
        });
    },
    async deleted(item) {
      if (await this.$modal.yesNo(this.$t("events.confirmDelete"))) {
        this.$modal.showLoading();
        this.requestApiDelete(`user/planning/${item.id}`)
          .then(({ data }) => {
            this.$toast.success(this.$t("events.successDelete"));
            this.$modal.hideLoading();
            this.setEvents();
            this.updateCalendarLocale();
            this.$emit("getData");
          })
          .catch(({ response }) => {
            this.$modal.hideLoading();
          });
      }
    },
    edit(item) {
      this.title = item.title;
      this.description = item.description;
      this.color.hex = item.color;
      this.calendar_id = item.id;
      this.start_at =
        this.$i18n.locale === "fa"
          ? moment(item.start_at, "YYYY-MM-DD HH:mm").format(
              "jYYYY/jMM/jDD HH:mm"
            )
          : item.start_at;
      this.end_at =
        this.$i18n.locale === "fa"
          ? moment(item.end_at, "YYYY-MM-DD HH:mm").format(
              "jYYYY/jMM/jDD HH:mm"
            )
          : item.end_at;
      this.dialog = true;
      this.updateable = true;
    },
    update() {
      this.$modal.showLoading();
      this.errors = [];
      this.requestApiPut(`user/update-calendar/${this.calendar_id}`, {
        method: "put",
        title: this.title,
        description: this.description,
        color: this.color.hex,
        start_at:
          this.$i18n.locale === "fa"
            ? moment(this.start_at, "jYYYY/jMM/jDD HH:mm").format(
                "YYYY-MM-DD HH:mm"
              )
            : this.start_at,
        end_at:
          this.$i18n.locale === "fa"
            ? moment(this.end_at, "jYYYY/jMM/jDD HH:mm").format(
                "YYYY-MM-DD HH:mm"
              )
            : this.end_at,
      })
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.setEvents();
          this.updateCalendarLocale(); // به‌روزرسانی تقویم پس از ویرایش
          this.closed();
          this.$emit("getData");
          this.$toast.success(this.$t("events.successUpdate"));
        })
        .catch(({ response }) => {
          this.errors = response.data.errors;
          this.$modal.hideLoading();
        });
    },
    closed() {
      this.dialog = false;
      this.updateable = false;
      this.calendar_id = null;
      this.description = null;
      this.title = null;
      this.errors = [];
      this.color = [];
      this.start_at = "";
      this.end_at = "";
    },
  },
  beforeDestroy() {
    if (this.calendar) {
      this.calendar.destroy();
    }
  },
};
</script>

<style scoped>
#scrollspy-example {
  position: relative;
  height: 200px;
  overflow-y: scroll;
  border: 1px solid blue;
}
</style>
